import React from "react";
import LabelValuePair from "../common/LabelValuePair";
import {AuditLog, AuditLogType, AuditLogTypeLabels,} from "../../models/AuditLog";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogNarrow } from "@/lib/dialogSize";

export const ViewDeleteAuditLogDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
}> = ({ auditLog, open, onClose }) => {
  const getLabelForAdditionalData = (eventType: AuditLogType): string => {
    switch (eventType) {
      case AuditLogType.ClientConfigurationDelete:
        return "Client Configuration Name";
      case AuditLogType.RefreshTokenDeleted:
        return "Token";
      case AuditLogType.OrganizationDeleted:
        return "Organization";
      case AuditLogType.ConsentLinkCreated:
        return "Link";
      default:
        return "Key";
    }
  };

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={`${dialogNarrow} overflow-hidden`}>
        {auditLog ? (
          <>
            <DialogHeader>
              <DialogTitle>
                {AuditLogTypeLabels[auditLog.eventType]}
              </DialogTitle>
            </DialogHeader>

            <Separator />

            <LabelValuePair
              label={getLabelForAdditionalData(auditLog.eventType)}
              value={auditLog.additionalData!}
            />

            <LabelValuePair
              label="Entity ID"
              value={auditLog.entityId!}
            />

            <LabelValuePair
              label="Performed By"
              value={auditLog.performerEmailAddress}
            />

            <LabelValuePair
              label="Event Date"
              value={auditLog.eventDate}
            />
          </>
        ) : (
          <div />
        )}
      </DialogContent>
    </Dialog>
  );
};
